// extracted by mini-css-extract-plugin
module.exports = {"container":"FullScreenSpinner_container__HZbHq","isSecondary":"FullScreenSpinner_isSecondary__EzzbO","billingSubmitting":"FullScreenSpinner_billingSubmitting__6_ekr"};